import type React from 'react';
import { Code2, Sparkles, Users } from 'lucide-react';
import { T2 } from './AppShellV2.tsx';

type Icon = React.ComponentType<{ size?: number; color?: string }>;

// Tint per domain; unknown future domains fall back to the neutral accent.
const DOMAIN_STYLE: Record<string, { Icon: Icon; bg: string; fg: string }> = {
  coding:  { Icon: Code2,    bg: 'var(--lyra-color-surface-2)', fg: '#0F766E' },
  hr:      { Icon: Users,    bg: 'var(--app-primary-soft)', fg: 'var(--lyra-color-primary)' },
  general: { Icon: Sparkles, bg: 'var(--app-primary-soft)', fg: 'var(--lyra-color-primary)' },
};

export const domainStyleFor = (domain: string) => DOMAIN_STYLE[domain] || { Icon: Sparkles, bg: T2.accentSoft, fg: T2.accent };

/** One-line descriptions shown on a connector row. Unknown domains use the agent's own description. */
const DOMAIN_COPY: Record<string, string> = {
  hr: 'Talent, projects and people data.',
  productivity: 'Tasks, weekly plans, ideas, notes and agent schedules.',
  coding: 'Code, repos, PRs and development tools.',
  general: 'General-purpose tools.',
};
export const domainCopyFor = (domain: string, fallback = '') => DOMAIN_COPY[domain] || fallback;
